import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-custom-alert-dialog',
  templateUrl: './custom-alert-dialog.component.html',
  styleUrls: ['./custom-alert-dialog.component.scss']
})
export class CustomAlertDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
